module.exports = __webpack_public_path__ + "static/img/theme2.9b39ef9a.jpg";